<div class="container  my-5">
  <div class="row mb-5">
      <div class="col">
          <h1>Typography (Hello World in H1)</h1>
          <h2>Hello world in H2</h2>
          <h3>Hello world in H3</h3>
          <h4>Hello world in H4</h4>
          <h5>Hello world in H5</h5>
          <p>Hello world in standard paragraph.</p>
      </div>
  </div>


  <h1>Buttons</h1>

  <div class="row mb-5">
      <div class="col-3">
          Submit button:<br />
          <wsb-atlas-button variant="primary-action" (click)="doSomething('Hello World')" [label]="'Click me now!'" [roundButton]="true">Click me now!</wsb-atlas-button>
      </div>
      <div class="col-3">
          Submit button with spinner:<br />
          <wsb-atlas-button variant="primary-action" [icon]="faCircleNotchIcon" [label]="'Click me now 2!'" [roundButton]="true">Click me now 2!</wsb-atlas-button>
      </div>
      <div class="col-3">
          Button primary:<br />
          <wsb-atlas-button variant="primary" [label]="'Click me now 2!'" [roundButton]="true">Click me now 2!</wsb-atlas-button>
      </div>
      <div class="col-3">
          Button secondary:<br />
          <wsb-atlas-button variant="secondary" [label]="'Click me now 2!'" [roundButton]="true">Click me now 2!</wsb-atlas-button>
      </div>
      <div class="col-3">
          Button tertiary:<br />
          <wsb-atlas-button variant="tertiary" [label]="'Click me now 2!'" [roundButton]="true">Click me now 2!</wsb-atlas-button>
      </div>
      <div class="col-3">
          Button link<br />
          <wsb-atlas-button variant="link" [label]="'Click me now 2!'" [roundButton]="true">Click me now 2!</wsb-atlas-button>
      </div>
      <div class="col-3">
          Button icon<br />
          <wsb-atlas-button variant="icon" [icon]="faCoffeeIcon" [roundButton]="true"></wsb-atlas-button>
          <wsb-atlas-button variant="icon-tertiary" [icon]="faCoffeeIcon" [roundButton]="true"></wsb-atlas-button>
      </div>
      <div class="col-3">
          Action button<br />
          <div class="dropdown">
              <wsb-atlas-button variant="secondary dropdown-toggle" [label]="'Action'" [roundButton]="true">Action</wsb-atlas-button>
              <div class="dropdown-menu" style="display:block;">
                <a class="dropdown-item selected" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <a class="dropdown-item" href="#">Something else here</a>
                <a class="dropdown-item error" href="#">Oops!</a>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </div>
      </div>
  </div>


  <h1>Cards</h1>

  <code>&lt;wsb-ui-card&gt;</code>

  <div class="row">
      <div class="col">
          <wsb-ui-card title="This is the card title" subtitle="Best choice">
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
              <p class="text-center">
                  <img src="https://picsum.photos/400/400" class="w-100">
              </p>

              <div wsb-ui-card-footer>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis sit illo impedit porro totam error quos a, similique magni velit sed deleniti tempora vitae in itaque tempore aperiam eveniet ea!</p>
                  <a href="#my_modal" (click)="doModal()" class="btn btn-primary">Go somewhere</a>
              </div>
          </wsb-ui-card>
      </div>
      <div class="col">
          <wsb-ui-card class="template" title="This is the card title">
              <img src="https://picsum.photos/200/300" class="w-100">
              <br>
              <br>
              <div wsb-ui-card-footer>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis sit illo impedit porro totam error quos a, similique magni velit sed deleniti tempora vitae in itaque tempore aperiam eveniet ea!</p>
                  <a href="#my_modal" (click)="doModal()" class="btn btn-primary">Go somewhere</a>
              </div>
          </wsb-ui-card>
      </div>
      <div class="col">
          <wsb-ui-card title="This is the card title">
              <img src="https://picsum.photos/200/300" class="w-100">
              <p>Some other content</p>
              <div wsb-ui-card-footer>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis sit illo impedit porro totam error quos a, similique magni velit sed deleniti tempora vitae in itaque tempore aperiam eveniet ea!</p>
                  <a href="#my_modal" data-toggle="modal" (click)="doModal()" class="btn btn-primary">Go somewhere</a>
              </div>
          </wsb-ui-card>
      </div>
  </div>

  <div class="row">
      <div class="col-md-8 col-md-offset-2">
          <div class="modal" tabindex="-1" id="my_modal" role="dialog">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Modal title</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <p>Modal body text goes here.</p>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                      <button type="button" class="btn btn-primary">Save changes</button>
                  </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

  <hr>

  <div class="row">
      <div class="col-12">
          <h1>Forms</h1>
      </div>
      <div class="col-4">
          <h2>Simple form</h2>
          <p>This is a simple short form.</p>
          <form>
              <div class="form-group">
                  <label for="exampleInputEmail1">Email address</label>
                  <small class="form-text text-muted">This is an help text before the input</small>
                  <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
              </div>
              <div class="form-group">
                  <label for="exampleInputPassword1">Password</label>
                  <input type="password" class="form-control" id="exampleInputPassword1">
                  <small class="form-text text-muted">This is an help text after the input</small>
              </div>
              <button type="submit" class="btn btn-primary">Submit</button>
          </form>
      </div>
      <div class="col-7 offset-1">
          <h2>Longer form</h2>
          <p>This is a longer form with more data.</p>
          <div class="form-horizontal">
              <div class="form-group row">
                  <label for="exampleInputEmail1" class="col-sm-2 col-form-label">Email</label>
                  <div class="col-sm-10">
                      <input type="email" class="form-control" id="exampleInputEmail1">
                      <small class="form-text text-muted">This is an help text after the input</small>
                  </div>
              </div>
              <div class="form-group row">
                  <label for="exampleInputEmail2" class="col-sm-2 col-form-label">Not valid</label>
                  <div class="col-sm-10">
                      <input type="email" class="form-control is-invalid" id="exampleInputEmail2" value="not valid value">
                      <div class="invalid-feedback">
                          Validation error message here
                      </div>
                      <small class="form-text text-muted">This is an help text after the input</small>
                  </div>
              </div>
              <div class="form-group row">
                  <label for="exampleInputPassword1" class="col-sm-2 col-form-label">Password</label>
                  <div class="col-sm-10">
                      <input type="password" class="form-control" id="exampleInputPassword1">
                  </div>
              </div>
              <div class="form-group row">
                  <label for="genericTextarea1" class="col-sm-2 col-form-label">Text area</label>
                  <div class="col-sm-10">
                      <div wsbAppTextarea class="form-control" [(ngModel)]="randomWithBreak"></div>
                  </div>
              </div>
              <button type="submit" class="btn btn-primary">Submit</button>
          </div>
      </div>
  </div>

  <div class="row">

  </div>

</div>
